// 发布状态（取消发布后回到未发布）
export const PublishStatusEnum = {
  NOT_PUBLISH: 0, // 未发布
  ALREADY_PUBLISH: 1, // 已发布
};

export const publishStatusList = [
  { value: 0, label: "未发布" },
  { value: 1, label: "已发布" },
];

// 报名审核状态
export const AuditStatusEnum = {
  WAIT_AUDIT: 0, // 待审核
  AUDIT_PASS: 1, // 审核通过
  AUDIT_REJECT: 2, // 审核驳回
};

export const auditStatusList = [
  { value: 0, label: "待审核" },
  { value: 1, label: "审核通过" },
  { value: 2, label: "审核驳回" },
];

// 签到状态
export const CheckinStatusEnum = {
  NOT_CHECKIN: 0, // 未签到
  CHECKINED: 1, // 已签到
};

export const checkinStatusList = [
  { value: 0, label: "未签到" },
  { value: 1, label: "已签到" },
];

// 报名记录状态（有效报名展示为“已报名”）
export const RecordStatusEnum = {
  VALID: 1, // 有效
  CANCELED: 2, // 已取消
};

export const recordStatusList = [
  { value: 1, label: "已报名" },
  { value: 2, label: "已取消" },
];

// 报名来源（1=用户主动报名 2=代邀）
export const registrationSourceList = [
  { value: 1, label: "用户主动报名" },
  { value: 2, label: "代邀" },
];

// 取消来源（1=用户端 2=管理端）
export const cancelSourceList = [
  { value: 1, label: "用户端" },
  { value: 2, label: "管理端" },
];

// 受邀记录参会情况（邀约记录管理；0=已报名（默认）1=确认参会 2=不参会）
export const attendStatusList = [
  { value: 0, label: "已报名" },
  { value: 1, label: "确认参会" },
  { value: 2, label: "不参会" },
];

// 是否参加（报名列表 5.1 口径，仅邀约记录返回；0=未确认（默认）1=参加 2=不参加，普通报名为 null）
export const attendFlagList = [
  { value: 0, label: "未确认" },
  { value: 1, label: "参加" },
  { value: 2, label: "不参加" },
];

// 展商企业状态（1=上架 0=下架）
export const EnterpriseStatusEnum = {
  OFF_SHELF: 0, // 下架
  ON_SHELF: 1, // 上架
};

export const enterpriseStatusList = [
  { value: 1, label: "上架" },
  { value: 0, label: "下架" },
];

// 活动状态（后端按活动起止时间计算）
export const ActivityStatusEnum = {
  NOT_STARTED: 1, // 未开始
  ONGOING: 2, // 进行中
  FINISHED: 3, // 已结束
};

export const activityStatusList = [
  { value: 1, label: "未开始" },
  { value: 2, label: "进行中" },
  { value: 3, label: "已结束" },
];

// 根据值取字典 label
export const findLabel = (list, value) => {
  const target = list.find((item) => item.value === value);
  return target ? target.label : "";
};

/**
 * @Description：下载接口返回的文件流（优先用服务端在 content-disposition 里的文件名，取不到用兜底名）
 * @Author cxd
 * @Date 2026/10/31
 */
export const downloadBlob = (res, fallbackName) => {
  let filename = fallbackName;
  try {
    const disposition = res.headers && res.headers["content-disposition"];
    if (disposition) {
      const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      const plain = disposition.match(/filename="?([^";]+)"?/i);
      const name = (encoded && encoded[1]) || (plain && plain[1]);
      if (name) {
        try {
          filename = decodeURIComponent(name);
        } catch (e) {
          filename = name;
        }
      }
    }
  } catch (e) {
    // 取不到响应头时用兜底文件名
  }
  const blob = new Blob([res.data]);
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.setAttribute("download", filename);
  a.click();
  URL.revokeObjectURL(objectUrl);
};

/**
 * @Description：字典数据归一化，兼容字符串数组及 value/label、dictValue/dictLabel、id/name 等结构
 * @Author cxd
 * @Date 2026/10/26
 */
export const normalizeDict = (data) => {
  const list = Array.isArray(data) ? data : [];
  return list
    .map((item) => {
      if (typeof item === "string" || typeof item === "number") {
        return { value: item, label: String(item) };
      }
      if (!item || typeof item !== "object") {
        return null;
      }
      const value =
        item.value != null ? item.value : item.dictValue != null ? item.dictValue : item.id;
      const label =
        item.label != null
          ? item.label
          : item.dictLabel != null
          ? item.dictLabel
          : item.name != null
          ? item.name
          : "";
      if (value == null) return null;
      return { value, label: label !== "" ? String(label) : String(value) };
    })
    .filter((item) => item);
};
